import React from 'react';

import { ShiftTextGroupProps } from './interfaces';

import { ShiftDescription,ShiftHeader, ShiftTextGroupContainer, ShiftTitle } from './styles/ShiftTextGroup';

/**
 * Shift text group component that displays header, title and description.
 * Used in shift-related pages and components.
 */

export const ShiftTextGroup = ({ header, title, description }: ShiftTextGroupProps) => (
  <ShiftTextGroupContainer>
    <ShiftHeader>{header}</ShiftHeader>
    <ShiftTitle>{title}</ShiftTitle>
    <ShiftDescription>{description}</ShiftDescription>
  </ShiftTextGroupContainer>
); 